import { forwardRef } from "react";

import { RefComponent } from "capitalrx-components-2.0/lib/forms/RefComponent";
import { Placeholder } from "capitalrx-components-2.0/lib/forms/Textbox/Placeholder";
import { TextboxProps, TextboxSubComponents } from "capitalrx-components-2.0/lib/forms/Textbox/Textbox";
import { withSubComponents } from "capitalrx-components-2.0/lib/utilities/withSubComponents";

import { Field } from "./Field";
import { Input } from "./Input";

interface AppTextboxProps extends TextboxProps {
  readonly useDigitsCounter?: boolean;
}

interface AppTextboxSubComponents extends TextboxSubComponents {
  readonly Field: typeof Field;
}

export const Textbox = withSubComponents<RefComponent<HTMLInputElement, AppTextboxProps>, AppTextboxSubComponents>(
  {
    Field,
    Placeholder,
  },
  forwardRef<HTMLInputElement, AppTextboxProps>(function Textbox(props, ref) {
    return <Input {...props} ref={ref} type="text" />;
  }),
);
